import React, { type ReactNode } from 'react';

import { DictionaryLanguageDto } from '@/api/generated/models/dictionary-language-dto';
import { type SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { getAppLanguage } from '@/utils/getAppLanguage.util.ts';

export const getDictionaryLabel = <T>(params: {
  language?: DictionaryLanguageDto;
  options: SelectSearchOptionModel<T>[];
  value: T;
}) => {
  const { language, options, value } = params;
  const lang = getAppLanguage();
  const found = options.find(it => it.value === value);
  if (!found) {
    return undefined;
  }
  if (typeof found.label === 'string') {
    return found.label;
  }
  return found.label[language ?? lang];
};

export const getSelectOptionLabel = <VALUE = string, LABEL extends ReactNode = string>(params: {
  language?: DictionaryLanguageDto;
  option: Partial<SelectSearchOptionModel<VALUE, LABEL>> | null | undefined;
}) => {
  const lang = getAppLanguage();
  const { language, option } = params;
  if (!option?.label) {
    return undefined;
  }
  if (typeof option.label === 'string' || React.isValidElement(option.label)) {
    return option.label;
  }

  if (typeof option.label === 'object') {
    const labelObject = option.label as Record<DictionaryLanguageDto, string>;
    return labelObject[language ?? lang] ?? labelObject[DictionaryLanguageDto.En];
  }

  return undefined;
};
